import { axiosPrivate } from "@/modules/common/api";

export async function getLocales(data: any) {
  const res = await axiosPrivate.post(`/api/v1/locales/all/`, data);
  return res;
}

export async function createLocale(data: any) {
  const res = await axiosPrivate.post(`/api/v1/locales/`, data);
  return res;
}

export async function updateLocale(locale_id: number, data: any) {
  const res = await axiosPrivate.patch(`/api/v1/locales/${locale_id}/`, data);
  return res;
}

export async function deleteLocale(locale_id: number) {
  const res = await axiosPrivate.delete(`/api/v1/locales/${locale_id}/`);
  return res;
}

export async function getLocaleById(employee_id: number) {
  const res = await axiosPrivate.get(`/api/v1/locales/${employee_id}/`);
  return res;
}
